module.exports = __webpack_public_path__ + "img/rogue-protocol.df9a1bde.png";